export default __webpack_public_path__ + "static/media/arrow-return.71b9689a.svg";